define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var Class = require('Class');
    var Backbone = require('backbone');
    var _ = require('underscore');

    var Carousel = Class.create(Backbone.Events, {

        initialize: function($el, $carouselTrack, carouselItemSelector, options) {
            this.$el = $el;
            this.el = $el[0];
            this.$carouselTrack = $carouselTrack;
            this.carouselItemSelector = carouselItemSelector;

            this.carouselIndex = 0;
            this.carouselParams = {};

            this.transformMethod = this.getSupportedTransformMethod() || 'transform';
            this._setOptions(options);

            this._setCarouselParams();

            this.runCarousel();
        },

        runCarousel: function() {
            this._setStylesForItems();

            if(this.shouldInitArrows()) {
                this._attachEvents();
                !this.infinityMode && this._updateArrowsState();
            } else {
                this._hideArrows();
            }
        },

        getSupportedTransformMethod: function() {
            var supportedStyles = _.keys(window.getComputedStyle(this.el || document.body));

            var transformMethods = supportedStyles.filter(function(key) {
                return key.match(/((^webkit)|(^moz)|(^ms)|(^))+transform$/i);
            });

            return transformMethods[0];
        },

        _setOptions: function(options) {
            this.$scrollLeft = options.$scrollLeft;
            this.$scrollRight = options.$scrollRight;
            this.scrollSize = options.scrollSize || 1;
            this.infinityMode = Boolean(options.infinityMode);
        },

        _setCarouselParams: function() {
            var carouselParams = this.carouselParams;
            var $carouselItems = this._getCarouselitems();

            carouselParams.itemWidth = $carouselItems[0].offsetWidth;
            carouselParams.itemsCount = $carouselItems.length;

            carouselParams.scrollLength = carouselParams.itemWidth * this.scrollSize;

            carouselParams.viewportWidth = this.el.offsetWidth;
            carouselParams.itemsCountInViewport = carouselParams.viewportWidth / carouselParams.itemWidth;
            carouselParams.itemsCountOutOfViewport = carouselParams.itemsCount - carouselParams.itemsCountInViewport;
        },

        _getCarouselitems: function() {
            return this.$el.find(this.carouselItemSelector);
        },

        _setStylesForItems: function() {
            var carouselItems = this._getCarouselitems();
            var carouselItemWidth = this.carouselParams.itemWidth;

            var itemsCountOutOfViewport = this.carouselParams.itemsCountOutOfViewport;
            var sizeOfLeftShift = parseInt(itemsCountOutOfViewport / 2);

            carouselItems.forEach(function(carouselItemEl, itemIndex) {
                var actualItemIndex = itemIndex - sizeOfLeftShift;
                var itemPosition = carouselItemWidth * actualItemIndex;

                carouselItemEl.style.left = itemPosition + 'px';
            });

            this.$el.css('height', this._getMaxCarouselHeight());
        },

        _getMaxCarouselHeight: function() {
            var carouselItems = this._getCarouselitems();

            var itemsHeight = carouselItems.map(function(carouselItem) {
                return carouselItem.offsetHeight;
            });

            itemsHeight.sort(function(current, next) {
                return next >= current;
            });

            var maxHeight = itemsHeight[0] + 'px';
            return maxHeight;
        },

        shouldInitArrows: function() {
            return this.carouselParams.itemsCountOutOfViewport > 0;
        },

        _attachEvents: function() {
            this.$scrollLeft.on('tap.slider', this.scrollToLeft.bind(this));
            this.$scrollRight.on('tap.slider', this.scrollToRight.bind(this));
        },

        _scroll: function(isScrollToLeft) {
            var scrollAmount;
            var scrollLength = this.carouselParams.scrollLength;
            var carouselIndexPosition = -this.carouselIndex;
            var scrollPosition = carouselIndexPosition * this.carouselParams.scrollLength;

            if(isScrollToLeft) {
                var moveLeft = -this.scrollSize;
                scrollAmount = scrollPosition + scrollLength;
                this._changeCarouselIndex(moveLeft);
            } else {
                var moveRight = this.scrollSize;
                scrollAmount = scrollPosition - scrollLength;
                this._changeCarouselIndex(moveRight);
            }

            !this.infinityMode && this._updateArrowsState();

            this.$carouselTrack.css(this.transformMethod, 'translate3d(' + scrollAmount + 'px, 0, 0)');
        },

        _updateArrowsState: function() {
            var $scrollLeftParent = this.$scrollLeft.parent();
            var $scrollRightParent = this.$scrollRight.parent();

            var startIndex = this.carouselIndex;
            var endIndex = this.carouselIndex + this.carouselParams.itemsCountInViewport;
            var lastElementIndex = this.carouselParams.itemsCount - 1;

            var isFirstSlide = startIndex === 0;
            var isLastSlide = endIndex === lastElementIndex || endIndex > lastElementIndex;

            if (isFirstSlide) {
                $scrollLeftParent.addClass('hidden');
                $scrollRightParent.removeClass('hidden');

            } else if (isLastSlide) {
                $scrollLeftParent.removeClass('hidden');
                $scrollRightParent.addClass('hidden');

            } else {
                $scrollLeftParent.removeClass('hidden');
                $scrollRightParent.removeClass('hidden');
            }
        },

        _hideArrows: function() {
            var $scrollLeftParent = this.$scrollLeft.parent();
            var $scrollRightParent = this.$scrollRight.parent();

            $scrollLeftParent.addClass('hidden');
            $scrollRightParent.addClass('hidden');
        },

        scrollToLeft: function() {
            this._scroll(true);
            this.infinityMode && this._moveLastElToStart();
        },

        scrollToRight: function() {
            this._scroll(false);
            this.infinityMode && this._moveFirstElToEnd();
        },

        _changeCarouselIndex: function(indexDiff) {
            this.carouselIndex = this.carouselIndex + indexDiff;
        },

        _moveFirstElToEnd: function() {
            var $carouselItems = this._getCarouselitems();

            var firstCarouselItemEl = $carouselItems.shift();
            var lastItemPosition = $carouselItems.pop().style.left;

            var itemPosition = parseInt(lastItemPosition) + this.carouselParams.itemWidth;
            $(firstCarouselItemEl).css('left', itemPosition + 'px');

            this.$carouselTrack.append(firstCarouselItemEl);
        },

        _moveLastElToStart: function() {
            var $carouselItems = this._getCarouselitems();

            var lastCarouselItemEl = $carouselItems.pop();
            var firstItemPosition = $carouselItems.shift().style.left;

            var itemPosition = parseInt(firstItemPosition) - this.carouselParams.itemWidth;
            $(lastCarouselItemEl).css('left', itemPosition + 'px');

            this.$carouselTrack.prepend(lastCarouselItemEl);
        },

        close: function() {
            this.$scrollLeft.off('tap.slider', this.scrollToLeft.bind(this));
            this.$scrollRight.off('tap.slider', this.scrollToRight.bind(this));
        }
    });

    module.exports = Carousel;
});
